import { render, staticRenderFns } from "./ResizeImage.vue?vue&type=template&id=5b7f6107"
import script from "./ResizeImage.vue?vue&type=script&lang=js"
export * from "./ResizeImage.vue?vue&type=script&lang=js"
import style0 from "./ResizeImage.vue?vue&type=style&index=0&id=5b7f6107&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports